// @flow
export const EMPLOYEE_NOT_FOUND: 'not_found' = 'not_found';
export const EMPLOYEE_THIS_SUPPLIER: 'this_supplier' = 'this_supplier'; // сотрудник столовой текущего поставщика
export const EMPLOYEE_OTHER_SUPPLIER: 'other_supplier' = 'other_supplier'; // сотрудник столовой другого поставщика
export const EMPLOYEE_OTHER_DEALER: 'other_employee' = 'other_employee'; // прочий сотрудник
export const EMPLOYEE_FOUND: 'found' = 'found';
